// This file is modified during CI builds. Do not change this
// file unless you know what you are doing
const APPLICATION_VERSION = "v1.448.2";

export const getApplicationVersion = (): string => APPLICATION_VERSION;
